<h2 class="text-center text-color font-bold text-2xl md:text-5xl mb-12">Hear From Those Who Trust Us!</h2>
<main class="w-full max-w-7xl mx-auto">

    <div class="overflow-hidden">
        <div
            class="flex transition-transform duration-500"
            [ngStyle]="{'transform': 'translateX(' + (-currentIndex * 100) + '%)'}">
            <div *ngFor="let slide of slides" class="w-full flex-shrink-0 flex flex-col md:flex-row items-center p-4">
                <div class="bg-white bg-opacity-70 p-6 rounded-lg shadow-md w-full ">
                    <p class="text-lg">{{ slide.text }}</p>

                    <div class="flex justify-between items-center">
                        <h2 class="text-xl font-semibold mt-4">{{ slide.name }}</h2>
                        <div class="w-[150px] text-4 h-[50px] bg-white flex items-center m-4">
                        <img [src]="slide.img" alt="avatar" class="w-full  rounded-lg">

                    </div>
                    </div>
                    <p class="text-gray-600">{{ slide.position }}</p>

                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-center mt-6">
        <span *ngFor="let btn of slides; let i = index"
              class="h-4 w-4 mx-2 rounded-full cursor-pointer"
              [ngClass]="{'bg-white w-6': i === currentIndex, 'bg-gray-400': i !== currentIndex}"
              (click)="setIndex(i)"></span>
    </div>
</main>
